import { useEffect, useMemo, useRef } from "react";
import { useTracks } from "@livekit/components-react";
import { type TrackPublication } from "livekit-client";
import { Track } from "livekit-client";
import type { ProviderScreenShareVideo } from "../types";
import { convertParticipantToPeer } from "./helpers";

export const useLivekitScreenShareVideo = (): ProviderScreenShareVideo => {
  const trackRefs = useTracks([Track.Source.ScreenShare], {
    onlySubscribed: true,
  });
  const screenSharePublication: TrackPublication = trackRefs[0]?.publication;
  const track = screenSharePublication?.track;
  const peer = useMemo(
    () =>
      trackRefs.length > 0
        ? convertParticipantToPeer(trackRefs[0].participant)
        : undefined,
    [trackRefs],
  );

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const videoElement = videoRef.current;
  const hasVideo = !screenSharePublication?.isMuted;

  useEffect(() => {
    if (videoElement && track) {
      track.attach(videoElement);
    }

    return () => {
      if (videoElement && track) {
        track.detach(videoElement);
      }
    };
  }, [videoElement, track]);

  return {
    peer,
    videoRef,
    hasVideo,
    shouldWarnInfinityMirror: false,
  };
};
